export default {
  file: {
    title1: '履歴事項全部証明書',
    title2: '銀行通帳',
    title3: '預金通帳(見開きページ)',
    btn: 'アップロード',
    label0: '代表者本人確認書類',
    label01: '(免許証、マイナンバーカード、在留カード、パスポート等)',
    label0Error: '法人証明書は空ではない',
    label1: '履歴事項全部証明書（発行3が月以内のもの）',
    labe1Error: '履歴事項全部証明書（発行3が月以内のもの）は空ではない',
    label2: '預金通帳(表紙)',
    label2Note: '(ネットバンキング画像の場合、銀行名、支店番号/支店名、口座番号、名義が同時に確認できるもの。)',
    labe2Error: '預金通帳(表紙)は空ではない',
    label3: '預金通帳(見開きページ)',
    labe3Error: '預金通帳(見開きページ)は空ではない',
    label4: '営業許可証等',
    labe4Error: '営業許可証等は空ではない',
    label5: '古物商許可証',
    label6: '風俗営業許可証',
    label7: '旅行業登録票（標識）',
    label8: '旅館業許可証、許可証あるいは証明書',
    label9: '自動車整備業認証書あるいは指定書',
    label10: 'その他',
    fileTip: 'ファイル形式：JPEG、PNG、JPG、 PDF。ファイルサイズ制限：10MB内',
    aboutIndustryTip: '下記業種に該当するお客様は該当許可証のご用意をお願いいたします。',
    aboutIndustrytrailTip: '上記以外にもお申込内容により、別途許認可証が必要になる場合がございます、ご了承ください。',

    tip: 'ファイルサイズ制限：10MB内',
    errorTypeTip: 'PNG、JPG、PDF ファイルのみ対応しています',
    request1: '「GlobePay決済加盟店規約」を確認・同意の上で申込する',
    request2: '上記の申込内容を相違のないことを確認し、同意の上で情報変更を申込する',
    confirmation: {
      title: '確認のお願い',
      content: '情報変更・決済ブランド追加に関しては、当社のGlobePay決済サービスへのお申込み・各ブランドの審査通過をもって加盟店契約成立となります。',
      instruction: '以下、規約および約款を再度ご確認いただき、同意の場合はチェックをお願いします。',
    },
    file: '「GLOBEPAY加盟店規約」',
    file2: 'を確認・同意の上で申込する',
    submitApplication: '申込',

    submit: '申込'
  }
}
